"use client";
import Image from "next/image";
import Container from "@/components/ui/container";

export default function ThumbsUpSection() {
  return (
    <div className='relative overflow-hidden py-12 md:py-24'>
      <Container className='relative'>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-4 items-center px-4'>
          {/* Text Content - moved to right column */}
          <div className='w-full flex flex-col gap-4 md:gap-8 order-2 md:order-2 md:pl-8 z-10'>
            <h2 className='text-4xl font-bold'>
              Keeping Workers Safe{" "}
              <span className='text-primary'>Since 2012</span>
            </h2>
            <p className='text-lg text-muted-foreground'>
              Our mission is simple: to help workers operate safely every day,
              so they can return home to their families. Since 2012, we&apos;ve
              been dedicated to providing high-quality safety products that
              protect people in demanding environments. Every solution we offer
              is designed with one goal in mind—ensuring everyone gets home
              safe.
            </p>
          </div>
          {/* Empty column for image positioning */}
          <div className='order-1 md:order-1'></div>
        </div>
      </Container>
      {/* Desktop image absolutely positioned outside container, only visible on md+ */}
      <div className='hidden md:block absolute top-0 bottom-0 left-0 w-1/2 overflow-hidden h-full'>
        <div className='w-full h-full relative'>
          <Image
            src='https://res.cloudinary.com/djowccubk/image/upload/v1747287579/images/AFS_Thumbs_Up.webp'
            alt='Vehicle Identification Distance Example'
            fill
            sizes='(min-width: 768px) 50vw, 100vw'
            className='object-cover object-center'
            loading='lazy'
            quality={70}
          />
        </div>
      </div>
      {/* Mobile image, only visible on small screens */}
      <div className='w-full h-[300px] relative order-1 md:static md:h-auto my-4'>
        <div className='block md:hidden w-full h-full relative'>
          <Image
            src='https://res.cloudinary.com/djowccubk/image/upload/v1747287579/images/AFS_Thumbs_Up.webp'
            alt='Vehicle Identification Distance Example'
            fill
            sizes='(max-width: 767px) 100vw'
            className='object-cover object-center'
            loading='lazy'
            quality={70}
          />
        </div>
      </div>
    </div>
  );
}
